<template>
  <div>
    <p>
      <strong
        >Cartera de consumo. Oferta válida en Argentina del
        <span data-obfuscate>{{ fechasInicio }}</span> al
        <span data-obfuscate>{{ fechaFin }}</span
        >.</strong
      >
    </p>
    <p>
      <strong>Beneficio comisión bonificada.</strong> <br />
      Las bonificaciones corresponden a las comisiones por mantenimiento mensual
      de cuenta y estarán vigentes siempre que mantengas la acreditación de
      haberes en tu cuenta sueldo de BBVA. Para acceder a la bonificación, debes
      recibir mensualmente una acreditación de haberes neta por un monto igual o
      superior a $300.000. Si en un mes no recibís acreditación de sueldo que
      supere el monto mensual indicado, y esta situación se repite en el mes
      calendario siguiente, perderás la bonificación y deberás abonar la
      comisión mensual correspondiente a tu Cuenta para ese período, conforme lo
      indicado en tabla de Comisiones y Gastos publicada
      https://www.bbva.com.ar/tablas/comision.pdf Los importes incluyen IVA. El
      Banco puede modificar los montos necesarios para alcanzar la bonificación,
      y te lo informará previamente.<br />
      Otorgamiento sujeto al cumplimiento de los requisitos exigidos por el
      departamento de créditos de Banco BBVA Argentina S.A. y demás condiciones
      de vinculación. Conocé más de la composición de las cuentas en
      www.bbva.com.ar.
    </p>
    <br />
    <br />
    <p>
      <strong>Cashback por acreditación de haberes.</strong>
      1. Haber recibido esta comunicación por parte de Banco BBVA Argentina
      S.A.<br />
      2. Comenzar a acreditar haberes en una cuenta sueldo de BBVA dentro del
      período de vigencia de la campaña (no aplica transferencias recibidas bajo
      el concepto “HABERES” ni pagos provenientes de billeteras virtuales).<br />
      3. Que hayan pasado más de 12 meses desde tu última acreditación de
      haberes en BBVA.<br />
      4. Recibir una acreditación mínima neta y mensual de $500.000 en tu cuenta
      sueldo de BBVA.<br />
      5. Al momento de registrar la primera acreditación de haberes en BBVA,
      haber realizado el alta y ser titular de un paquete Express, Gold,
      Platinum o Black.<br />
      6. Haber acreditado tus haberes en BBVA durante 2 meses consecutivos. Si
      cumplís estos requisitos, recibirás un premio de bienvenida de acuerdo al
      tipo de Paquete: Black cashback de
      <span data-obfuscate>{{ cashbackWorld }}</span>
      en 3 cuotas iguales y consecutivas de {{ cashbackWorldCuota }};Platinum
      cashback de
      <span data-obfuscate>{{ cashbackPremium }}</span>
      en 3 cuotas iguales y consecutivas de {{ cashbackPremiumCuota }}; Paquete
      Gold cashback de
      <span data-obfuscate>{{ cashbackGold }}</span>
      en 3 cuotas iguales y consecutivas de {{ cashbackGoldCuota }}; Express
      cashback de
      <span data-obfuscate>{{ cashbackExpress }}</span>
      en 3 cuotas iguales y consecutivas de {{ cashbackExpressCuota }}. La
      primera cuota del cashback será acreditada en tu cuenta VISA BBVA
      vinculada a tu paquete dentro de los 90 días hábiles posteriores de
      registrar la primera acreditación de haberes y las siguientes serán en los
      meses consecutivos siempre y cuando mantengas la acreditación mínima y
      mensual requerida. De lo contrario se perderá el beneficio.<br />
      Esta promoción no es acumulable con ninguna otra promoción de beneficios
      por acreditar haberes en BBVA. En caso de haber sido referido o ingresado
      por el motor https://www.bbva.com.ar/abrir-cuenta-sueldo/#/ o por Banca
      Online o App BBVA antes, durante o después de haber recibido esta oferta y
      mientras dure la vigencia de esa campaña, la campaña “referidos”
      prevalecerá por sobre cualquier otra promoción a la que te hayas suscrito
      incluyendo esta, luego se priorizarán las campañas del motor o sitio
      privado y por último la oferta detallada en esta campaña.
    </p>
  </div>
</template>

<script>
import { packageCode } from "@/config/constants/packagesCodes";
import { cashbackPaquetes } from "../../config/constants/packageAwards";
import { mapState } from "vuex";

export default {
  name: "Legales",
  data() {
    return {
      fechasInicio: "07/04/2026",
      fechaFin: "30/09/2026",
      fechaMantenimientoDesde: "01/06/2025",
      cashbackPremium: cashbackPaquetes.LIBRETON_PREMIUM,
      cashbackFull: cashbackPaquetes.LIBRETON_FULL,
      cashbackWorld: cashbackPaquetes.LIBRETON_PREMIUM_WORLD,
      cashbackGold: cashbackPaquetes.LIBRETON_PLUS_GOLD,
      cashbackExpress: cashbackPaquetes.LIBRETON_EXPRESS,
      cashbackPremiumCuota: cashbackPaquetes.LIBRETON_PREMIUM_CUOTA,
      cashbackFullCuota: cashbackPaquetes.LIBRETON_FULL_CUOTA,
      cashbackWorldCuota: cashbackPaquetes.LIBRETON_PREMIUM_WORLD_CUOTA,
      cashbackGoldCuota: cashbackPaquetes.LIBRETON_PLUS_GOLD_CUOTA,
      cashbackExpressCuota: cashbackPaquetes.LIBRETON_EXPRESS_CUOTA,
      comisionExpress: "$28.000",
      comisionGold: "$45.000",
      comisionFull: "$45.000",
      comisionPremium: "$62.000",
      comisionWorld: "$74.000"
    };
  },
  computed: {
    esPaquetePremium() {
      return (
        this.tipoPaquete === packageCode.LIBRETON_FULL ||
        this.tipoPaquete === packageCode.LIBRETON_PREMIUM ||
        this.tipoPaquete === packageCode.LIBRETON_PREMIUM_WORLD
      );
    },
    ...mapState({
      tipoPaquete: state => state.paquetesBeneficios.caracteristicas.tipoPaquete
    })
  }
};
</script>
